var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("custom-tabs.add-tab")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("custom-tabs.labels.name"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.Name,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Name", $$v)
                      },
                      expression: "value.Name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("custom-tabs.labels.title"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.Title,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Title", $$v)
                      },
                      expression: "value.Title",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("custom-tabs.labels.url"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.Url,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Url", $$v)
                      },
                      expression: "value.Url",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("w-row"),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-button", { staticClass: "cancel", on: { click: _vm.close } }, [
            _vm._v(_vm._s(_vm.$t("common.cancel"))),
          ]),
          _c("w-spacer"),
          _c("w-button", { on: { click: _vm.save } }, [
            _vm._v(_vm._s(_vm.$t("common.save"))),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }